module.exports = ".m-brand__tools {\n  width: 75px; }\n"